export default class IDMGlobals {}

//AppID@v1 - LEGACY code
IDMGlobals.AppIDEncryptionAlgorithm = 'aes-256-ctr';
IDMGlobals.AppIDTokenValidityPeriod = 1000; //seconds
//Cookies
IDMGlobals.CookiesDefaultExpirationPeriod = 140000;//days
IDMGlobals.CookiesLongLiveExpirationPeriod = 300000;//days
IDMGlobals.CookiesPublicKeyExpiration = 4;//hours
IDMGlobals.CookiesSecureStorage = true;//
//Cookies values
IDMGlobals.CookiesKey_IDMToken = 'idm_token_v4';
IDMGlobals.CookiesKey_IDMRenewalToken = 'idm_renewal_token_v4';
IDMGlobals.CookiesKey_IDMResourcesToken = 'idm_resouces_token_v4';
IDMGlobals.CookiesKey_IDMSessionData = 'idm_session_data_v4';


IDMGlobals.CookiesKey_IDMToken_OLD = 'idm_token_v2';
IDMGlobals.CookiesKey_IDMRenewalToken_OLD = 'idm_renewal_token_v2';
IDMGlobals.CookiesKey_IDMResourcesToken_OLD = 'idm_resouces_token_v2';
IDMGlobals.CookiesKey_IDMSessionData_OLD = 'idm_session_data_v2';

IDMGlobals.CookiesKey_IDMPublicKey = 'idm_public_key';
IDMGlobals.CookiesKey_IDMExternalProviders = 'idm_external_providers';

//URL query parameters
IDMGlobals.URLQueryParam_UserEmail = 'user';
IDMGlobals.URLQueryParam_AppID = 'appauth'; //legacy
IDMGlobals.URLQueryParam_AppIDv2 = 'appauthv2';
IDMGlobals.URLQueryParam_IDMToken = 'idm';
IDMGlobals.URLQueryParam_ClientEnrollRole = 'role';
IDMGlobals.URLQueryParam_RegConfirmationToken = 'regToken';
IDMGlobals.URLQueryParam_RegConfirmationCode = 'regCode';
IDMGlobals.URLQueryParam_Email = 'useremail';
IDMGlobals.URLQueryParam_RegConfirmationResetEmail = 'regEmail';
IDMGlobals.URLQueryParam_PartsID = 'partsID';
IDMGlobals.URLQueryParam_RecaptchaToken = 'recaptchaToken'; //case insensitive
IDMGlobals.URLQueryParam_ClientCallbackURL = 'cb';
IDMGlobals.URL_ChangePassword = '/?changePassword=1';
IDMGlobals.API_newConstant = 'new'
//JWT
  //validation gap - this is leave a security gap for token usage, eg.: if
  //token expires in 60 seconds and our gap is 10 seconds, we will consider
  //the token invalid in 50 seconds
IDMGlobals.JWTExpirationGap = (60*10); //10 minutes -- //gap in seconds


//API
IDMGlobals.APIPath_Login = '/login';
IDMGlobals.APIPath_Logout = '/logout';
IDMGlobals.APIPath_Validate = '/validate';
IDMGlobals.APIPath_Challenge = '/challenge';
IDMGlobals.APIPath_PublicKey = '/publickey';
IDMGlobals.APIPath_ExternalProviders = '/federation';
IDMGlobals.APIPath_Application = '/app/';
IDMGlobals.APIPath_ApplicationDetailed = '/detailed';
IDMGlobals.APIPath_Applications = '/apps';
IDMGlobals.APIPath_AccessToken = '/accessToken/';
IDMGlobals.APIPath_AccessTokens = '/accessTokens';
IDMGlobals.APIPath_Role = '/role/';
IDMGlobals.APIPath_Roles = '/roles';
IDMGlobals.APIPath_User = '/user/';
IDMGlobals.APIPath_UserEmail = '/user/email/';
IDMGlobals.APIPath_Users = '/users';
IDMGlobals.APIPath_UsersSearch = '/users/search/term';
IDMGlobals.APIPath_UsersPartsSearch = '/users/search/part/userIDs';
IDMGlobals.APIPath_UsersPartsByIDsSearch = '/users/search/part/IDs';
IDMGlobals.APIPath_UserMFA = '/mfa';
IDMGlobals.APIPath_UserEnable= '/enable'
IDMGlobals.APIPath_UserDisable = '/disable'
IDMGlobals.APIPath_UserPassword = '/password';
IDMGlobals.APIPath_UserPartition = '/part/';
IDMGlobals.APIPath_UserSomePartition = '/someParts/';
IDMGlobals.APIPath_UserPartitions = '/parts';
IDMGlobals.APIPath_PartitionACL = '/partACL/';
IDMGlobals.APIPath_PartitionACLs = '/partACLs';
IDMGlobals.APIPath_Registration = '/register/';
IDMGlobals.APIPath_SMSMFA = '/sms-mfa/';
IDMGlobals.APIPath_RegistrationConfirmation = '/register/confirm';

//Authorization challenge states
IDMGlobals.AuthorizationChallengeState_PasswordResetRequired = 'PASS_RESET_REQ';
IDMGlobals.AuthorizationChallengeState_NewPasswordRequired = 'NEW_PASS_REQ';
IDMGlobals.AuthorizationChallengeState_MFASetupRequired = 'MFA_SETUP_REQ';
IDMGlobals.AuthorizationChallengeState_MFARequired = 'MFA_REQ';
IDMGlobals.AuthorizationChallengeState_SMSMFARequired = 'SMS_MFA_REQ';
IDMGlobals.AuthorizationChallengeState_Authorized = 'AUTH_OK';
IDMGlobals.AuthorizationChallengeState_ConfirmationRequired = 'CONFIRM_REQ';
IDMGlobals.AuthorizationChallengeState_NotFound = 'NOT_FOUND';
IDMGlobals.AuthorizationChallengeState_Disabled = 'DISABLED';
IDMGlobals.AuthorizationChallengeState_Locked = 'LOCKED';
IDMGlobals.AuthorizationChallengeState_Unknown = 'UNKNOWN';
//Authorization error codes
IDMGlobals.AuthorizationChallengeState_Forbidden = 'AUTH_FORBIDDEN'; //cognito denied response
IDMGlobals.AuthorizationErrorCode_InvalidAppAuth = 'INVALID_APP_AUTH'; //app auth is forbidden
IDMGlobals.AuthorizationErrorCode_ExpiredAppAuth = 'APP_AUTH_EXP'; //app auth is expired
IDMGlobals.AuthorizationErrorCode_AppAuthNotFound = 'APP_AUTH_NOT_FOUND'; //app auth could be decoded but not found (deleted?)
IDMGlobals.AuthorizationErrorCode_AppAuthNoApp = 'APP_AUTH_NO_APP'; //app auth exists but no app is associated with it (system issue?)
IDMGlobals.AuthorizationErrorCode_InvalidAuthToken = 'INVALID_AUTH_TOKEN'; //invalid app auth token
IDMGlobals.AuthorizationErrorCode_Restricted = 'RESTRICTED'; //User has no permission to acess this route
IDMGlobals.AuthorizationErrorCode_NoAppAccess = 'NO_APP_ACCESS'; //User has no access within current requesting application
IDMGlobals.AuthorizationErrorCode_InvalidMFACode = 'INVALID_MFA_CODE'; //Invalid/expired MFA code

//Bad request error codes
IDMGlobals.ErrorCode_NotFound = 'NOT_FOUND';
IDMGlobals.ErrorCode_IncorrectBehaviour = 'INCORRECT_BEHAVIOUR';
IDMGlobals.ErrorCode_OpNotAllowed = 'OP_NOT_ALLOWED';
